// @flow

import type { State as GlobalState } from '../../types';

import {
  getModel,
  getMake,
  getFueltype,
  getPower,
  getEngine,
  getBodystyle,
  getShortestDeliveryTime,
  getActivePdbId,
  getPrice,
} from '../../pdb';

import {
  getCartPrice,
  getActiveDurationValue,
  getActiveMileageValue,
  getActiveColorName,
  getActivePackage,
} from '../../configuration';

type carConfigurationType = {
  id: string,
  name: string,
  category: string,
  brand: string,
  variant?: string,
  package: string,
  color: string,
  bodystyle: string,
  delivery: number,
  duration: string,
  mileage: string,
  price: number,
  quantity: number,
};

export const getConfiguration = (
  state: GlobalState,
  pdbId?: ?string,
): ?carConfigurationType => {
  const id = pdbId || getActivePdbId(state) || '0';
  const activePackage = getActivePackage(state);
  const engine = activePackage ? activePackage.engine : getEngine(state);
  const power = activePackage ? activePackage.power : getPower(state);
  const variant = `${engine || ''} ${power || ''} ${getFueltype(state) || ''}`;
  const category = getModel(state, id);
  const brand = getMake(state, id);
  const name = `${brand} ${category}`;
  const bodystyle = getBodystyle(state, id);
  const duration = getActiveDurationValue(state) || '0';
  const mileage = getActiveMileageValue(state) || '0';
  const delivery = getShortestDeliveryTime(state, id);
  const price = getCartPrice(state, id);
  const basePrice = getPrice(state, id);
  const color = getActiveColorName(state) || '';
  const packageName = activePackage ? activePackage.name : '';

  const quantity = 1;

  return {
    id,
    name,
    category,
    brand,
    variant,
    package: packageName || '',
    color,
    bodystyle,
    delivery,
    duration,
    mileage,
    price,
    basePrice,
    quantity,
    engine,
    power,
  };
};

export default null;
